import validate from "/opt/render/project/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45global from "/opt/render/project/src/middleware/01.redirect.global.js";
import manifest_45route_45rule from "/opt/render/project/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}